// Curated against official sources on 27 September 2026.
// Dates are announcement dates unless explicitly labelled as effective dates.
const latestUpdatesByCountry = {
  switzerland: [
    {
      label: "Transparency register pilot",
      date: "16 Jun 2026",
      dateIso: "2026-06-16",
      dateType: "Announced",
      text: "The Federal Office of Justice launched a voluntary pilot of the beneficial-ownership register to test its infrastructure and reporting processes before the new law takes effect on 1 October 2026.",
      source: "Swiss federal authorities",
      sourceUrl: "https://www.sif.admin.ch/de/newnsb/WFpbtbbMBSLL",
    },
    {
      label: "AML reform: start date set",
      date: "12 Jun 2026",
      dateIso: "2026-06-12",
      dateType: "Announced",
      text: "The Federal Council set 1 October 2026 as the commencement date for the revised AMLA and the new beneficial-ownership transparency law. The reforms cover certain high-risk advisory activities and introduce a transparency register; registration transition periods start on that date. State-notary provisions are deferred.",
      source: "Federal Council / SIF",
      sourceUrl: "https://www.sif.admin.ch/en/newnsb/x3sKLxCJ6S3dQJtfvy0Tb",
    },
    {
      label: "FINMA risk-analysis guidance",
      date: "04 Jun 2026",
      dateIso: "2026-06-04",
      dateType: "Published",
      text: "FINMA Guidance 04/2026 supplements its AML risk-analysis guidance for banks and FinIA institutions. It highlights weaknesses in risk-tolerance limits and risk-analysis methods, including how excluded countries, client segments, services and products align with the business model.",
      source: "FINMA",
      sourceUrl: "https://www.finma.ch/en/news/2026/06/20260604-mm-am-04-26/",
    },
  ],
  uae: [
    {
      label: "Updated CBUAE AML guidance",
      date: "16 Apr 2026",
      dateIso: "2026-04-16",
      dateType: "Announced",
      text: "The Central Bank announced updated AML, counter-terrorist financing and proliferation-financing guidance. The package supports licensed financial institutions and registered hawala providers in understanding financial-crime risks and strengthening compliance systems. Scope: CBUAE-supervised institutions.",
      source: "Emirates News Agency / CBUAE",
      sourceUrl: "https://www.wam.ae/en/article/bzqun23-cbuae-updates-amlcftcpf-guidance-for-licensed",
    },
    {
      label: "New AML executive regulations",
      date: "14 Dec 2025",
      dateIso: "2025-12-14",
      dateType: "Effective",
      text: "Cabinet Resolution No. 134 of 2025 implements the new federal AML law. It addresses financial institutions, designated non-financial businesses and professions, virtual-asset service providers, and beneficial-ownership transparency. It replaces Cabinet Resolution No. 10 of 2019.",
      source: "CBUAE Rulebook",
      sourceUrl: "https://rulebook.centralbank.ae/en/entiresection/6843",
    },
    {
      label: "New federal AML law",
      date: "14 Oct 2025",
      dateIso: "2025-10-14",
      dateType: "Effective",
      text: "Federal Decree-Law No. 10 of 2025 establishes the updated framework for combating money laundering, terrorist financing and proliferation financing. It covers preventive measures, beneficial ownership, supervisory powers, penalties and international cooperation.",
      source: "UAE Legislation",
      sourceUrl: "https://uaelegislation.gov.ae/en/legislations/3314",
    },
  ],
};

export function latestUpdatesForCountry(country) {
  return latestUpdatesByCountry[country] || [];
}
